import { FiskalContract }      from '@app/modules/contract/models/contract.model';
import { FiskalContractState } from '@app/modules/contract/store/fiskal-contract-store/fiskal-contract.state';
import { ActionTypeWithProps } from '@core/interfaces/store.interface';
import {
	adapterActions,
	IAdapterActions,
	IBaseProps
}                              from '@core/store/adapter/adapter.actions';
import {
	createAction,
	props
}                              from '@ngrx/store';

export interface IFiskalContractActions extends IAdapterActions<FiskalContract> {
	updateContractState: ActionTypeWithProps<IPropsUpdateFiskalContractState>;
}


export interface IPropsUpdateFiskalContractState extends IBaseProps {
	stateUpdateData?: FiskalContractState;
}


export function fiskalContractActions( storeId: string ) {
	return {
		// AdapterActions ##########################################################################################################################
		...adapterActions<FiskalContract>( storeId ),

		// CONTRACT SPECIFICATION ACTIONS ###########################################################################################################
		updateContractState: createAction( `[${ storeId }] State Update`, props<IPropsUpdateFiskalContractState>() )
	};
}
